/** Created by azhou on 2019/2/15.*/
<template>
<div>
  <div class="d-center">
    <span :class="[required ? 'text-danger':'text-white','mr-small']">*</span>
    <div class="form-left-text lies" >{{leftText}}</div><span class="lies-top">：</span>
    <div class="option-wrap"> 
      <left-text-border class="mb-2"
                              inputId="inputTitle"
                              v-model="valueInside"
                              :leftText="''"
                              />
      <div class="mt-2 text-left text-muted d-flex">
        <div>推荐选择：</div><el-radio-group class="group" v-model="valueInside" @change="(v)=>{ this.$emit('input',v) }" >
        <el-radio  v-for="item in options"
          :key="item"
          :label="item"
          :value="item">{{item}}</el-radio>
        </el-radio-group>
      </div>
      
    </div>
  </div>

</div>
</template>

<script>
export default {
  name: 'LeftTextRadio',
  props: {
    value: {},
    leftText: {
      type: String
    },
    placeholder: {
      type: String
    },
    required: {
      type: Boolean,
      default: false
    },
    options: {
      type: Array,
      default() {
        return [];
      }
    }
  },
  data() {
    return {
      valueInside: ''
    };
  },
  created() {
    //当prop传入的值没有发生变化时，组件被重新创建后需要再次赋值
    if (this.value) this.valueInside = this.value;
  },
  watch: {
    value() {
      this.valueInside = this.value;
      this.$emit('input',this.value) 
    },
    valueInside() {
      this.$emit('input',this.valueInside) 
    }
  }
};
</script>

<style scoped lang="scss">
.d-center {
  justify-content: inherit;
  align-items: flex-start;
  line-height: 27px;
}

.option-wrap {
  flex: 1;
  .group {
    display: flex;
    flex-wrap: wrap;
  }
}
.lies{
  padding-top: 8px;
}
.lies-top{
  padding-top: 2px;
}
</style>
<style>
  .text-muted .el-radio{
    margin-right: 15px;
    padding-top: 5px;
  }
  .text-muted .el-radio .el-radio__input{
  }
</style>
